import Cookies from 'js-cookie';

import { getCookieRootDomain } from './browser';

const LANGUAGE_COOKIE_NAME = 'NGDP_LANG';

/**
 * get the language from the cookie used in e-boks Classic
 * @returns
 */
export const getLanguageFromCookie = (): string => Cookies.get(LANGUAGE_COOKIE_NAME);

/**
 * set the language on the cookie used in e-boks classic
 * @param isoCode
 */
export const setLanguageOnCookie = (isoCode: string): void => {
    Cookies.set(LANGUAGE_COOKIE_NAME, isoCode, { domain: getCookieRootDomain() });
};
